import React, { FC, ReactNode } from "react";
import classNames from "classnames";

import { MoneyLabel } from "../../common/MoneyLabel";
import { CURRENCY_MAP } from "../../../constants";
import { Currency } from "../../../types/InvoiceTypes";

type Props = {
  label: ReactNode;
  className?: string;
  currency: Currency;
  amount: number;
  hint?: ReactNode;
};

export const InvoiceSummaryBox: FC<Props> = ({
  amount,
  className,
  currency,
  label,
  hint,
}) => {
  const { symbol } = CURRENCY_MAP[currency];

  return (
    <div className={classNames("flex flex-col  gap-0 md:gap-2", className)}>
      <div className="font-semibold text-gray-800">{label}</div>

      <div className="flex items-start gap-2">
        <MoneyLabel amount={amount >= 0 ? amount : 0} currency={symbol} />
      </div>

      {hint && (
        <div className="text-sm text-violet-300 grow-0 flex items-start">
          {hint}
        </div>
      )}
    </div>
  );
};
